<template lang="pug">
    include /@ibkr/lib.common/src/icon/basic
    
    .ib-col(class="flex")
        .ib-row
            .ib-col
                .ib-col(class="insety-16")
                    label(class="bold bond-title fg70") Category:&ensp;
                        ib-dropdown( 
                            class="inset-8",
                            width="20ch",
                            name= "categoryselect",
                            :data="categories", 
                            v-model="categoryValue",
                            @change="onChange()"  
                        )

                                    
        ib-table-basic.ib-row.shrink.fs7.fg70.insety-16.event-border(
            :data="events",
            spacing="huge",
            ref="table",
            wrap,
            rowstripe,
            rowborder,
            colborder,
        )
            ib-table-col.event-header-border-right(width="10ch") {{ $t('date_time') }}
            ib-table-col.event-header-border-right(width="10ch") {{ $t('region') }}
            ib-table-col.event-header-border-right(width="32ch") {{ $t('event') }}
            ib-table-col.event-header-border-right(width="10ch") {{ $t('category') }}
            template(slot="body" slot-scope="row")
                td(class="")
                    span(class="") {{ dateFormat(row.date) }}
                td(class="")
                    span(class="") {{ getRegion(row.region) }}
                td(class="")
                    span(class="bold") {{ row.subject}} <br>
                    span(class="pre-wrap") {{ row.description}}
                td(class="")
                    span(class="") {{ getCategory(row.category) }}
                       
</template>

<script>
    import api from '../api/'
    import { categories } from '../js/categories.js'
    import { regions } from '../js/regions.js'

    export default {

        components: {
 
        },

        data() {
            return {
                events: [],
                categories: categories(this),
                regions: regions(this),
                categoryValue: '0',
                categoryLabel: '',
           }
        },
        created() {

        },

        mounted() {
            this.getEvents(this.categoryValue);
            this.getCategory(this.categoryValue);
        },

        watch: {
           
        },
        computed: {

        },

        methods: {         
            getEvents(categoryValue){
                api.getEvents(categoryValue)
                    .then(res => {
                        this.events = res;
                   }); 
            },

            onChange() {                
                const curCategory = this.categories.filter(c => c.value === parseInt(this.categoryValue));
                this.categoryLabel = curCategory[0].label;
                this.getEvents(this.categoryValue);
            },

            getRegion(val){
                const curRegion = this.regions.filter(r => r.value === val);
                return curRegion[0].label;
            },

            getCategory(val){
                const curCategory = this.categories.filter(c => c.value === parseInt(val));
                return curCategory[0].label;
            },
            
            dateFormat(val) {
                const dateformat = val && val.substring(0,10);
                if (dateformat) {
                    return dateformat;
                }
                return '-';
            }

        }
}
</script>

<style lang="less">
.fg-sell-events-header {
  color:var(--dark);
  font-weight:300;
  font-size:2.5rem;
  line-height: 2.75rem;
} 


.pointer {
    cursor: pointer;
}


.over-auto {
    overflow: auto;
}
.pre-wrap{
    white-space: pre-wrap;
}

.event-border{
    ._tb{
        border-style:solid;
        border-width:1px;
        border-color:rgba(0, 0, 0, 0.1);
    }
}

.event-header-border-right{
    border-right-style:solid;
    border-right-width:1px;
    border-right-color:rgba(0, 0, 0, 0.1);
}

.event-header-font{
    font-weight:0;
}

.matdate {
    label {
        display: block;
    }
    //override
    ._field {
        border-radius: 3px;
    }
}
</style>
